export enum EVia {
  EMAIL = 'email',
  PHONE = 'phone',
}

export enum EMode {
  SIGNUP = 'Sign up',
  LOGIN = 'Login',
  // VERIFICATION = 'Continue',
  // PROFILE = 'Agree and Sign up',
}

export enum EButtonText {
  PHONE_LOGIN = 'Login via email',
  PHONE_SIGNUP = 'Sign up via email',
  EMAIL_LOGIN = 'Login via phone',
  EMAIL_SIGNUP = 'Sign up via phone',
}

export type TButtonGroupsProps = {
  via: keyof typeof EVia;
  mode: keyof typeof EMode;
  onChangeVia: (type: keyof typeof EVia) => void;
};
